import {VStack, HStack, Box, Text, Image, Button, Icon, ListIcon, useBreakpointValue} from "@chakra-ui/react";
import { FaMicrophone, FaGlobe, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import ReactPlayer from "react-player/lazy";
import React from "react";
import LazyLoad from "react-lazyload";
import {useAuth} from "../../redux/AuthProvider";
import URLInput from "./URLInput";

const TwoColumnRow = ({ title, description, features, buttonText, mediaSrc, mediaType, reverse, theFileInput,
                          onOpenSignUpScreen1, urlInput, setUrlInput, handleSubmit, currentPlaceholder, fade }) => {
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm' || breakpoint === 'md';
    const auth = useAuth();

    return (
        !isMobile ?
            <HStack justify="space-between" width="100%" flexDirection={reverse ? 'row-reverse' : 'row'} bg={'white'}>
                {/* Left side - Text content */}
                <VStack align="flex-start" spacing={5} width={reverse ? '45%' : '50%'} bg={'white'}>
                    <Text fontSize={'3xl'} fontWeight="bold" textAlign={'left'}>
                        {title}
                    </Text>
                    <Text fontSize={17.5} textAlign={'left'}>
                        {description}
                    </Text>
                    <VStack align="flex-start" spacing={3} mt={0} mb={3}>
                        {features.map((feature, index) => (
                            <HStack key={index}>
                                {/*<ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={3} />*/}
                                <Icon as={FaCheckCircle} color="green.500" mt={0} mr={2.5} />
                                <Text fontSize={17} fontWeight={'600'} textAlign={'left'}>{feature.text}</Text>
                            </HStack>
                        ))}
                    </VStack>
                    {title === "Chat with YouTube videos." && auth.isLoggedIn ?
                        <Box width={'100%'}>
                            <Box width={'100%'}>
                                <URLInput
                                    urlInput={urlInput}
                                    setUrlInput={setUrlInput}
                                    handleSubmit={handleSubmit}
                                    currentPlaceholder={currentPlaceholder}
                                    fade={fade}
                                />
                            </Box>
                        </Box> :

                        <Button
                            borderRadius={12}
                            px={6}
                            py={6}
                            fontSize={18}
                            colorScheme={'orange'}
                            bgGradient="linear(to-r, gray.800, gray.900)"
                            _hover={{
                                bgGradient: "linear(to-r, gray.800, black)", // Adjusts the gradient on hover
                                boxShadow: 'lg' // Adds a slight shadow on hover
                            }}
                            onClick={() => {
                                if (buttonText === "Get started") {
                                    onOpenSignUpScreen1();
                                } else {
                                    theFileInput.current.click();
                                }
                            }}>
                            {buttonText}
                        </Button>}
                </VStack>

                {/* Right side - Image/Graphic */}
                <Box width={reverse ? '50%' : '45%'} display={'flex'} alignItems={'center'} bg={'white'}>
                    {mediaType === "image" && title === "Chat with any PDF." ?
                            <Image src={mediaSrc} alt={title} width={'100%'} borderRadius={19}/>
                        :
                        mediaType === "image" ?
                            <Image src={mediaSrc} alt={title} width={'100%'} borderRadius={19} position="relative"
                                   transform="translateY(0)"
                                   transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                   _hover={{
                                       transform: "translateY(-8px)",
                                       boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                                   }}
                                   boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                                   _before={{
                                       content: '""',
                                       position: 'absolute',
                                       top: '-2px',
                                       left: '-2px',
                                       right: '-2px',
                                       bottom: '-2px',
                                       background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                       borderRadius: !isMobile ? 22 : 2,
                                       zIndex: -1,
                                       opacity: 0.8
                                   }}
                                   _after={{
                                       content: '""',
                                       position: 'absolute',
                                       top: 0,
                                       left: 0,
                                       right: 0,
                                       bottom: 0,
                                       background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                       borderRadius: !isMobile ? 20 : 0,
                                       pointerEvents: 'none',
                                       zIndex: 1
                                   }}/>
                     : (
                        <Box width={'100%'}
                             borderRadius={20}
                             overflow="hidden" position="relative"
                             transform="translateY(0)"
                             transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                             _hover={{
                                 transform: "translateY(-8px)",
                                 boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                             }}
                             boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                             _before={{
                                 content: '""',
                                 position: 'absolute',
                                 top: '-2px',
                                 left: '-2px',
                                 right: '-2px',
                                 bottom: '-2px',
                                 background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                 borderRadius: !isMobile ? 22 : 2,
                                 zIndex: -1,
                                 opacity: 0.8
                             }}
                             _after={{
                                 content: '""',
                                 position: 'absolute',
                                 top: 0,
                                 left: 0,
                                 right: 0,
                                 bottom: 0,
                                 background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                 borderRadius: !isMobile ? 20 : 0,
                                 pointerEvents: 'none',
                                 zIndex: 1
                             }}>
                            <LazyLoad height={'auto'} width={'100%'} offset={100}>
                                <ReactPlayer
                                    url={mediaSrc}
                                    playing={true}
                                    loop={true}
                                    playbackRate={1}
                                    muted={true}
                                    controls={true}
                                    width={'100%'}
                                    height="auto"
                                />
                            </LazyLoad>
                        </Box>
                    )}
                </Box>
            </HStack> :










            <VStack width="100%" bg={'white'}>
                {/* Left side - Text content */}
                <VStack align="flex-start" spacing={5} width={'100%'} bg={'white'}>
                    <Text fontSize={'3xl'} fontWeight="bold" textAlign={'left'}>
                        {title}
                    </Text>
                    <Text fontSize={17.5} textAlign={'left'}>
                        {description}
                    </Text>
                    <VStack align="flex-start" spacing={3} mt={0} mb={3}>
                        {features.map((feature, index) => (
                            <HStack key={index}>
                                {/*<ListIcon as={FaCheckCircle} color="green.500" mt={1} mr={3} />*/}
                                <Icon as={FaCheckCircle} color="green.500" mt={0} mr={2.5} />
                                <Text fontSize={17} fontWeight={'600'} textAlign={'left'}>{feature.text}</Text>
                            </HStack>
                        ))}
                    </VStack>
                    {title === "Chat with YouTube videos." && auth.isLoggedIn ?
                        <Box width={'100%'}>
                            <Box width={'100%'}>
                                <URLInput
                                    urlInput={urlInput}
                                    setUrlInput={setUrlInput}
                                    handleSubmit={handleSubmit}
                                    currentPlaceholder={currentPlaceholder}
                                    fade={fade}
                                />
                            </Box>
                        </Box> :
                        <Button
                            borderRadius={12}
                            px={6}
                            py={6}
                            fontSize={18}
                            colorScheme={'black'}
                            bgGradient="linear(to-r, gray.800, gray.900)"
                            _hover={{
                                bgGradient: "linear(to-r, gray.800, black)", // Adjusts the gradient on hover
                                boxShadow: 'lg' // Adds a slight shadow on hover
                            }}
                            onClick={() => {
                                if (buttonText === "Get started") {
                                    onOpenSignUpScreen1();
                                } else {
                                    theFileInput.current.click();
                                }
                            }}>
                            {buttonText}
                        </Button>
                    }
                </VStack>

                {/* Right side - Image/Graphic */}
                <Box width={'100%'} display={'flex'} alignItems={'center'} bg={'white'} mt={8} borderRadius={20}>
                    {mediaType === "image" && title === "Chat with any PDF."  ?
                        <Image src={mediaSrc} alt={title} width={'100%'} borderRadius={19}/> :
                        mediaType === "image" ?
                            <Image src={mediaSrc} alt={title} width={'100%'} borderRadius={19} position="relative"
                                   transform="translateY(0)"
                                   transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                                   _hover={{
                                       transform: "translateY(-8px)",
                                       boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                                   }}
                                   boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                                   _before={{
                                       content: '""',
                                       position: 'absolute',
                                       top: '-2px',
                                       left: '-2px',
                                       right: '-2px',
                                       bottom: '-2px',
                                       background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                       borderRadius: !isMobile ? 22 : 2,
                                       zIndex: -1,
                                       opacity: 0.8
                                   }}
                                   _after={{
                                       content: '""',
                                       position: 'absolute',
                                       top: 0,
                                       left: 0,
                                       right: 0,
                                       bottom: 0,
                                       background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                       borderRadius: !isMobile ? 20 : 0,
                                       pointerEvents: 'none',
                                       zIndex: 1
                                   }}/>
                     : (
                        <Box width={'100%'}
                             borderRadius={20}
                             overflow="hidden" position="relative"
                             transform="translateY(0)"
                             transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                             _hover={{
                                 transform: "translateY(-8px)",
                                 boxShadow: `
        0 25px 50px -12px rgba(0, 0, 0, 0.25),
        0 25px 100px -12px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.1)
      `
                             }}
                             boxShadow={`
      0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04),
      0 0 0 1px rgba(0, 0, 0, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.1)
    `}
                             _before={{
                                 content: '""',
                                 position: 'absolute',
                                 top: '-2px',
                                 left: '-2px',
                                 right: '-2px',
                                 bottom: '-2px',
                                 background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 50%, 
        rgba(0, 0, 0, 0.05) 100%
      )`,
                                 borderRadius: !isMobile ? 22 : 2,
                                 zIndex: -1,
                                 opacity: 0.8
                             }}
                             _after={{
                                 content: '""',
                                 position: 'absolute',
                                 top: 0,
                                 left: 0,
                                 right: 0,
                                 bottom: 0,
                                 background: `linear-gradient(135deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        transparent 50%
      )`,
                                 borderRadius: !isMobile ? 20 : 0,
                                 pointerEvents: 'none',
                                 zIndex: 1
                             }}>
                            <LazyLoad height={'auto'} width={'100%'} offset={100}>
                                <ReactPlayer
                                    url={mediaSrc}
                                    playing={true}
                                    loop={true}
                                    playbackRate={1}
                                    muted={true}
                                    controls={true}
                                    width={'100%'}
                                    height="auto"
                                />
                            </LazyLoad>
                        </Box>
                    )}
                </Box>
            </VStack>
    );
};

export default TwoColumnRow;
